import { ChevronDown } from 'baseui/icon';
import { CloseSVG } from 'common/assets';
import { string2money } from 'common/utils/string';
import { Form, Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import useDrawer from 'hooks/use-drawer';
import {
  ButtonContainer,
  SeparatorHorizontal,
  SummaryContent,
  SummaryLeftContainer,
  SummaryRightContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryDrawer from './summary-drawer';
import useRecalculate from '../../hooks/use-recalculate';
import { TicketSaleFormType } from '../form-type';

interface Props {}

export default function SummaryFlightSale(props: Props) {
  const { t } = useTranslation();
  const drawer = useDrawer();
  const methods = useFormContext<TicketSaleFormType>();
  const {
    reset,
    formState: { isSubmitting },
    getValues,
  } = methods;

  const onOpenSummaries = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      render: (close) => {
        return (
          <Form methods={methods} onSubmit={() => {}}>
            <SummaryDrawer onClose={close} />
          </Form>
        );
      },
    });
  }, [drawer, methods]);

  const { total } = useRecalculate();
  const { editable, setIsEditable } = useFormState();
  const showCancel = editable && getValues('ticketSale') && !isSubmitting;

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {t('common:total_sales')}:
        </Text>
        <SeparatorHorizontal $margin={16} />
        <Text
          variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}
        >{`Rp. ${string2money(total)}`}</Text>
        <SeparatorHorizontal $margin={16} />
        <IconButton buttonType="tertiary" onClick={onOpenSummaries}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
      <SummaryRightContainer>
        {showCancel && (
          <>
            <ButtonContainer
              $style={{
                marginLeft: '16px',
              }}
            >
              <Button
                onClick={() => {
                  reset();
                  setIsEditable(false);
                }}
                buttonType="secondary"
                startEnhancer={(color, size) => (
                  <CloseSVG width={size} height={size} color={color} />
                )}
                disabled={isSubmitting}
              >
                {t('common:cancel')}
              </Button>
            </ButtonContainer>
            <SeparatorHorizontal $margin={16} />
          </>
        )}
        <Input
          type="submit"
          overrides={{
            Root: {
              style: {
                flex: 1,
              },
            },
          }}
        />
      </SummaryRightContainer>
    </SummaryContent>
  );
}
